import { Brain, Code, Database, Globe } from 'lucide-react';

export interface ToolMode {
  icon: any;
  name: string;
  active: boolean;
}

// Default tool configurations
export const DEFAULT_TOOL_MODES: ToolMode[] = [
  // { icon: Globe, name: 'Web Search', active: true },
  { icon: Code, name: 'Coder', active: false },
  { icon: Brain, name: 'Deep Think', active: false },
  // { icon: Database, name: 'MCP Mode', active: false },
  // Commented out tools that might be added in the future
  // { icon: Vault, name: 'Vestige', active: false },
  // { icon: FileSearch, name: 'Asalytic', active: false },
  // { icon: Fingerprint, name: 'DID Resolver', active: true },
];
